export default {
  mounted() {
    this.el.hook = this
    this.el.proxyPushEventTo = (action, payload) => {
      this.pushEventTo(this.el, action, payload)
    }
  },
  findProxyParent(element) {
    while (element) {
      element = element.parentElement
      if (!element) return null
      if (element.getAttribute('phx-hook') === 'ProxyHook') return element
    }
    return null
  },
}
